// libaries
import $ from 'jquery';

// shared
import {ready, track} from 'shared/utils';

ready(() => {
  document.cookie = 'screen_width = ' + window.screen.width;
  document.cookie = 'screen_height = ' + window.screen.height;

  $(document).on('click', '[data-segment-track="button"]', function() {
    var $this = $(this);
    var buttonName = $this.data('buttonName');

    if (buttonName) {
      track('Button Clicked', {
        buttonName: buttonName
      });
    }
  });

  $('body').on('click', '[data-segment-track="link"]', function() {
    var $this = $(this);
    var linkName = $this.data('linkName');

    if (linkName) {
      track('Link Clicked', {
        linkName: linkName
      });
    }
  });
});
